import type { FC } from 'react'
import { Route, Routes } from 'react-router-dom'
import { paths } from './links.js'

import { SetupPage } from './SetupPage.js'
import { RequireFullNamePage } from './RequireFullNamePage.js'

export const SetupRoutes: FC = () => (
  <Routes>
    <Route path={paths.SETUP_PROFILE} element={<SetupPage />} />
    <Route path={paths.SETUP_NAME} element={<RequireFullNamePage />} />
  </Routes>
)
